import React from 'react';

import { IIconProps, TIconType } from '../interface';

const BackIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='back-icon'
			fill='none'
			height='25'
			viewBox='0 0 24 25'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M8.23047 12.5146L3.73047 8.01465L8.23047 3.51465'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M8.23047 18.5146L16.4805 18.5146C17.8729 18.5146 19.2082 17.9615 20.1928 16.977C21.1773 15.9924 21.7305 14.657 21.7305 13.2646V13.2646C21.7305 11.8723 21.1773 10.5369 20.1928 9.55234C19.2082 8.56777 17.8729 8.01465 16.4805 8.01465L3.73047 8.01465'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default BackIcon;
